module.exports = __webpack_public_path__ + "static/story3-01-800x533-9bcceb49ff6abe874fd9fba37491f2e7.jpg";